export const privateDico = {
    teaser: {
        title: "Bonjour",
        text: "Bienvenue sur votre espace Diode, recherchez une convention collective, consultez son champ d'application et ses obligations, utilisez le champ de recherche ci-dessous.",
        links: {
            cgu: {
                to: "/espace-client/cgu",
                label: "Conditions générales d'utilisation",
            },
            account: {
                to: "/espace-client/mon-compte",
                label: "Mon compte",
            },
        },
    },
    menu: {
        dashboard: { label: "Mon espace" },
        cc: { label: "Conventions collectives" },
        panorama: { label: "Panorama des conventions" },
        mag: { label: "Magazine" },
        contact: { label: "Nous contacter" },
    },
    search: {
        title: "Rechercher une convention collective",
        subtitle: "Rechercher parmi nos %s conventions collectives",
    },
    convention: {
        themes: {
            CT: "CONDITIONS DE TRAVAIL",
            CO: "CONGES ET JOURS FERIES",
            AH: "DUREE DU TRAVAIL",
            RE: "DEPART A LA RETRAITE",
            LI: "LICENCIEMENT",
            MA: "MALADIE - ACCIDENT",
            MT: "MATERNITE",
            PR: "PREVOYANCE",
            RS: "RETRAITE SUPPLEMENTAIRE",
            EP: "EPARGNE D'ENTREPRISE",
            FO: "FORMATION PROFESSIONNELLE",
            CL: "CLASSIFICATIONS",
            AS: "SALAIRES",
            PA: "PRIMES ET INDEMNITES",
            BI: "AUTRES THEMES",
        },
        type: {
            syndiquee: "Syndiquée",
            "non-syndiquee": "Non syndiquée",
            etendue: "Etendue",
            "info-vns": "Info VNS",
            "non-applicable": "Non Applicable",
            "nego-en-cours": "Négociation en cours",
        },
        typeTooltip: {
            syndiquee:
                "Pour l'entreprise adhérente de l'une des organisations patronales signataires de la convention.",
            "non-syndiquee":
                "Pour l'entreprise non adhérente de l'une des organisations patronales signataires de la convention.",
            etendue: "Pour toute entreprise relevant du champ d’application de la convention.",
        },
        teaser: {
            brochure: "Numéro de brochure",
            idcc: "IDCC n°",
            national: "Nationale",
            local: "Locale",
        },
        ca: {
            territorial: "Territorial",
            pro: "Professionnel",
            exlusions: "Exclusions",
            departement: "Département",
            activite: "Activité",
            territoire: "Territoire",
        },
        filters: {
            allCsp: "Toutes les catégories concernées",
        },
        menu: {
            presentation: { label: "Presentation" },
            ca: { label: "Champ d'application" },
            obligations: { label: "Obligations" },
            "compact-info": { label: "Informations compactées" },
        },
        csps: {
            "csp-ou": { label: "Ouvrier", color: "#F27781" },
            "csp-em": { label: "Employé", color: "#B09615" },
            "csp-am": { label: "Agent de Maîtrise", color: "#04BF8A" },
            "csp-ca": { label: "Cadre", color: "#18298C" },
            "csp-di": { label: "Divers", color: "#F29F05" },
        },
        cspFilterItems: [
            { code: "AM", label: "Agent de Maîtrise" },
            { code: "CA", label: "Cadre" },
            { code: "DI", label: "Divers" },
            { code: "EM", label: "Employé" },
            { code: "OU", label: "Ouvrier" },
        ],
        des: {
            withDes: "Avec la mention “Degré élevé de solidarité”",
            withoutDes: "Sans la mention “Degré élevé de solidarité”",
        },
    },
    apenafs: {
        A: "APE",
        N2003: "NAF2003",
        N2008: "NAF2008",
        N2025: "NAF2025",
    },
    mag: {
        title: "Diode Magazine",
        subtitle: "Toute l'information sociale de la rédaction",
        cover: "/espace-client/assets/images/mag/cover.jpg",
        covers: {
            "flashs-information-sociale": "/espace-client/assets/images/mag/flashs.jpg",
            "lois-decrets": "/espace-client/assets/images/mag/lois-decrets.jpg",
            "jurisprudence-sociale-selectionnee-cours-derniers-mois":
                "/espace-client/assets/images/mag/jurisprudence.jpg",
            others: "/espace-client/assets/images/mag/dossiers.jpg",
        },
        flash: {
            title: "Flash info Diode",
            subtitle:
                "Consulter l’actualité sociale des dernières publications au Journal Officiel",
            cta: {
                label: "Voir tous les flash infos",
                path: "",
            },
        },
    },
    cgu: {
        acceptance_checkbox: "J'ai lu et j'accepte les conditions générales d'utilisation.",
        accept_cta: "Valider",
    },
};
